// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import Int64LookupResourceViewModel from '../../../../viewModel/resource/Int64LookupResourceViewModel';
import ResourceTypeViewModel from '../../../../viewModel/resource/ResourceTypeViewModel';
import ReferentListResourceViewModel from '../../../../viewModel/resource/ReferentListResourceViewModel';
import ReferentListResourceDTO from '../../dto/resource/ReferentListResourceDTO';

export default abstract class ReferentListResourceModel extends BaseModel<ReferentListResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get caption() { return this.dto.caption; }
  set caption(value) { this.dto.caption = value; }
  /**
  */
  get details() { return this.dto.details; }
  set details(value) { this.dto.details = value; }
  /**
  */
  get group() { return this.getObjectModel(() => this.dto.group, Int64LookupResourceViewModel)!; }
  set group(value) { this.setObjectModel(() => this.dto.group, value); }
  /**
  * @type {int32}
  */
  get sortOrder() { return this.dto.sortOrder; }
  set sortOrder(value) { this.dto.sortOrder = value; }
  /**
  * @type {int32}
  */
  get employeeNumber() { return this.dto.employeeNumber; }
  set employeeNumber(value) { this.dto.employeeNumber = value; }
  /**
  */
  get firstName() { return this.dto.firstName; }
  set firstName(value) { this.dto.firstName = value; }
  /**
  */
  get lastName() { return this.dto.lastName; }
  set lastName(value) { this.dto.lastName = value; }
  /**
  */
  get fullName() { return this.dto.fullName; }
  /**
  */
  get referentTypes() { return this.getArrayModels(() => this.dto.referentTypes, Int64LookupResourceViewModel)!; }
  set referentTypes(value) { this.setArrayModels(() => this.dto.referentTypes, value); }
  /**
  * @type {int32}
  */
  get schedulerResourceType() { return this.dto.schedulerResourceType; }
  set schedulerResourceType(value) { this.dto.schedulerResourceType = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.caption = qs.caption;
    value = Number.parseFloat(qs.sortorder);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.sortOrder = value;
    value = Number.parseFloat(qs.employeenumber);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.employeeNumber = value;
    this.dto.firstName = qs.firstname;
    this.dto.lastName = qs.lastname;
    value = Number.parseFloat(qs.schedulerresourcetype);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.schedulerResourceType = value;
  }
}
